/**
 * Container
 * 
 * @Author: Focci
 * @Date: 2023-06-12 11:00:02
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-12 11:00:02
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function Container({
  className = '',
  children 
}) {
  return (
    <div className={clsx(['px-2 md:px-4 mx-auto max-w-full', className])}>
      { children }
    </div>
  )
}

Container.propTypes = {
  className: PropTypes.string,
}

export function WrapperContainer({
  className = 'pt-2 pb-10',
  subtile = false, // 是否添加背景颜色
  children
}) {
  return (
    <div className={clsx([subtile && 'bg-cf0', className])}>
      <Container className="w-274">
        {children}
      </Container>
    </div>
  )
}
